import useData from '~/pages/subscription/hooks/useData'

function LiveValidate() {
  const { accessLiveClasses } = useData()

  return accessLiveClasses
}

export default LiveValidate
